import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { portalApi } from '../../utils/portalApi';

export default function EmployeeArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    portalApi.listAdminArticles().then((data) => setArticles(data.articles || [])).catch((err) => setError(err.message));
  }, []);

  return (
    <section>
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold text-slate-900">Articles</h1>
        <Link to="/articles/new" className="rounded-lg bg-cam-blue px-4 py-2 text-white hover:bg-cam-blue/90">Create New Article</Link>
      </div>
      {error ? <p className="mt-4 text-sm text-red-600">{error}</p> : null}
      <div className="mt-6 overflow-hidden rounded-2xl bg-white ring-1 ring-slate-200">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-left text-slate-600">
            <tr>
              <th className="px-4 py-3">Title</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Publish date</th>
              <th className="px-4 py-3">Updated</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.slug} className="border-t">
                <td className="px-4 py-3">
                  <p className="font-medium text-slate-900">{article.title}</p>
                  <p className="text-xs text-slate-500">/{article.slug}</p>
                </td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-2 py-1 text-xs uppercase ${article.status === 'published' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                    {article.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-slate-600">{article.publishDate || '—'}</td>
                <td className="px-4 py-3 text-slate-600">{new Date(article.updatedAt || Date.now()).toLocaleDateString()}</td>
                <td className="px-4 py-3">
                  <Link className="text-cam-blue hover:underline" to={`/articles/edit/${article.slug}`}>Edit</Link>
                </td>
              </tr>
            ))}
            {!articles.length ? (
              <tr>
                <td colSpan={5} className="px-4 py-10 text-center text-slate-500">No articles yet. Create your first article.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
}
